import { Design } from './Design';

export default Design;
